<template>
  <transition name="fade" appear mode="out-in">
    <div id="overlay" v-show="submitting">
      <transition name="fade" appear mode="out-in">
        <div class="row spinner">
          <div class="" id="loader">
            <!-- <div class="loader"></div> -->
            <!-- <p class="line-1 anim-typewriter">Loading...</p> -->
            <img src="/img/rocket-loading.gif" width="400" height="400">
            <!-- <h1 :class="finalTitleClass">{{title}}</h1>
            <h4 :class="finalDescriptionClass">{{description}}</h4> -->
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'spinner',
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    submitting: {
      type: Boolean,
      default: false,
    },
    overlay: {
      type: Boolean,
      default: false,
    },
    titleClass: {
      type: String,
      default: '',
    },
    descriptionClass: {
      type: String,
      default: '',
    },
  },
  computed: {
    finalTitleClass() {
      const classes = ['title'];
      if (this.titleClass) classes.push(this.titleClass);
      return classes;
    },
    finalDescriptionClass() {
      const classes = [];
      if (this.descriptionClass) classes.push(this.descriptionClass);
      return classes;
    },
  }
};
</script>
<style lang="scss">
  #loader {
    height:100vh; 
    width: 100vw; 
    background: url('/img/background-loader.png'); 
    background-size: 100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
